import { render, staticRenderFns } from "./LoaderModal.vue?vue&type=template&id=cc0e53bc&scoped=true"
import script from "./LoaderModal.vue?vue&type=script&lang=js"
export * from "./LoaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0e53bc",
  null
  
)

export default component.exports